﻿import * as Models from '../../models/models';



export class AdminPaymentViewModel {
   
    policyholder: Models.IPolicyholder;
    billingStatement: Models.IBillingStatement;
    cardPaymentMethods: Array<Models.ICardPaymentMethod>;
    echeckPaymentMethods: Array<Models.IEcheckPaymentMethod>;
    isSubmitted: boolean = false;
    selectedPaymentTokenId: string = "";
    isPaymentMethodDisabled = true;
    paymentResponse: Models.IPaymentResponse;
    paymentAmount: number;
    policyholderPaymentNotification: Models.IPolicyholderPaymentNotification;
    paymentNotificationEmailAddressEditable: boolean = false;

    public hasBillingStatement = ():boolean => {
        return angular.isDefined(this.billingStatement.billedAndUnpaidBalance) && this.billingStatement.billedAndUnpaidBalance !==null;
    };

    public isPastDue = (): boolean => {
        if (this.hasBillingStatement()) 
        {
            if(angular.isDefined(this.billingStatement.pastDueBalance) && this.billingStatement.pastDueBalance !==null)
            {
                return this.billingStatement.pastDueBalance > 0;
            }
            return false;
        }
        return false;
    };

    public isPaymentAmountGreaterThanAmountDue = (): boolean => {

        return this.paymentAmount > this.amountDueValue();
    };

    public isPaymentAmountGreaterThanTotalBalance = (): boolean => {

        return this.paymentAmount > this.billingStatement.totalBalance;
    };

    public hasCurrentDueDate = (): boolean => {
        
                if (this.hasBillingStatement()) 
                {
                    return angular.isDefined(this.billingStatement.currentDueDate) && this.billingStatement.currentDueDate !==null;
                }
                return false;
            };

    public hasNextDueDate = (): boolean => {

        if (this.hasBillingStatement()) 
        {
            return angular.isDefined(this.billingStatement.nextDueDate) && this.billingStatement.nextDueDate !==null;
        }
        return false;
    };

    public amountDueHeader = (): string => {
        if (this.isPastDue()) {
            return "Past Due Amount";
        } else {
            return "Amount Due";
        }
    };

    public amountDueValue = (): number => {

        if (this.hasBillingStatement()) {
            if (this.isPastDue()) {
                return this.billingStatement.pastDueBalance;
            } else {
                return this.billingStatement.billedAndUnpaidBalance;
            }
        } else {
            return 0;
        }
    };

    public autoPayStatus = (): string => {

        if (angular.isDefined(this.policyholder) && this.policyholder !==null) {
            if (this.policyholder.autopay) {
                return "ON";
            } else {
                return "OFF";
            }
        } else {
            return "";
        }

    };

    public dueCardPaymentMethodsExist = (): boolean => {

        if (angular.isDefined(this.cardPaymentMethods) && this.cardPaymentMethods!==null) {

            if (this.cardPaymentMethods.length > 0) {
                return true;
            }
        }
        return false;
    };

    public dueEcheckPaymentMethodsExist = (): boolean => {

        if (angular.isDefined(this.echeckPaymentMethods) &&  this.echeckPaymentMethods !==null)
        {

            if (this.echeckPaymentMethods.length > 0) {
                return true;
            }
        }

        return false;
    };

    public duePaymentMethodsExist = (): boolean => {

        if (this.dueCardPaymentMethodsExist()) {
            return true;
        }

        if (this.dueEcheckPaymentMethodsExist()) {

            return true;
        }

        return false;
    }

}
